import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold text-textPrimary text-left" }, "Sair sem enviar a transcrição?", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-left" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-textPrimary" }, " A folha de monitoramento ainda não foi enviada para conciliação. Ao sair agora, tudo o que foi transcrito nesta sessão será perdido. ")
], -1)
const _hoisted_3 = { class: "flex flex-col sm:flex-row sm:justify-end gap-3" }

import Modal from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'

/**
 * RF-07/RN-10 (#2115) — a sessão de edição é efêmera e não tem auto-save; sair com ao
 * menos uma linha em uso (RN-03) descarta a transcrição em memória. Este modal é o
 * único aviso antes disso — nenhum caminho de saída descarta em silêncio. Sem
 * referência visual no protótipo (RF-11): segue o padrão visual do modal de troca de
 * modelo (`DsAttendanceSwitchTemplateModal`).
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'DsAttendanceUnsavedExitModal',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit }) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    "modal-active": _ctx.modelValue,
    "has-header-border": "",
    "has-footer-border": "",
    "max-width": "max-w-[480px]",
    onClose: _cache[2] || (_cache[2] = ($event: any) => (emit('update:modelValue', false)))
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(OutlineButton, {
          text: "Cancelar",
          width: "96px",
          height: "40px",
          "data-testid": "unsaved-exit-cancel-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', false)))
        }),
        _createVNode(FilledButton, {
          text: "Sair sem enviar",
          class: "bg-primary30",
          width: "160px",
          height: "40px",
          "data-testid": "unsaved-exit-confirm-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('confirm')))
        })
      ])
    ]),
    default: _withCtx(() => [
      _hoisted_2
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})